import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'PeopleFoneCurrencyFormat'})
export class CurrencyPipe implements PipeTransform {
  transform( value: number): string {

    let inputString = value.toString(10);

    if ( inputString.includes('.') ) {
      value = value * 100;
      inputString = value.toString(10);
      if ( inputString.includes('.') ) {
        inputString = inputString.split('.')[0];
      }
    }

    const length = inputString.length;
    if ( length === 0 ) {
      return '0.00';
    }
    let toReturn = '';
    if (length <= 2) {
      toReturn += '0.';
      toReturn += length === 2 ? inputString : '0' + inputString;
    } else {
      const decimals = inputString.substr(length - 2);
      let left = inputString.substr(0, length - 2);
      if (left.length > 3) {
        if (left.length % 3 > 0) {
          toReturn += left.substr(0, left.length % 3);
          toReturn += '\'';
          left = left.substr(left.length % 3);
        }
        while (left.length > 0) {
          toReturn += left.substr(0, 3);
          left = left.substr(3);
          toReturn += left.length > 0 ? '\'' : '';
        }
      } else {
        toReturn += left;
      }
      toReturn += '.' + decimals;
    }

    return toReturn;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/currency.pipe.ts